//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'mint-ui';
import { formatTime, guid, isNullOrEmptyStr } from "@/utils/common"
import { BASIC, PROJ_URL } from "@/config/constant"
import promise from '@/axios/promise';
export default {
  name: 'dayReportAdd',
  data() {
    return {
      type: this.$route.query.type,
      detailId: this.$route.query.detailId,
      status: this.$route.query.status,
      userInfo: {},
      totalHour: '',
      totalPirce: 0,
      solo: true,
      form: {
        id: this.$route.query.id,
        signId: '',
        reportTime: this.$route.query.reportDate,
        reportAddr: '',
        signTime: '',
        signAddr: '',
        signCity: '',
        reportLongitude: '',
        reportDimension: '',
        reportCityCode: '',
        reportCity: '',
        reportPlace: '',
        status: '',
        creater: '',
        createTime: '',
        deptId: '',
        deptCode: '',
        totalHour: '',
        totalPrice: 0,
        deptName: '',
        grade: '',
        userType: '',
        origTotalSubsidy: 0,
        workTotalSubsidy: 0,
        workTotalHour: 0,
        origTotalHour: 0,
        //日报补贴金额
        workSubsidyAmt: 0,
        unitPriceType: undefined,
      },
      modifyDetail: {},
      reportDetailList: [],
      projList: [],
      workHourList: [],
      // 结算单价类型
      unitPriceTypes: [{ code: 0, name: "现场" }, { code: 1, name: "远程" }],
    }
  },
  methods: {
    //返回
    goBack() {
      this.$router.push({ path: '/app/workRep/dayReport', query: { calDate: formatTime(this.form.reportTime, 'yyyy-MM-dd') } });
    },
    getWorkSubsidyAmt() {
      var self = this;
      promise({
        url: BASIC + "/dic/item/list/cateCode",
        mounted: 'get',
        params: { cateCode: 'workSubsidyAmt' }
      }).then(res => {
        self.workSubsidyAmt = res[0].dicCode;
      });
    },
    getWorkHourList() {
      var self = this;
      promise({
        url: BASIC + "/dic/item/list/cateCode",
        mounted: 'get',
        params: { cateCode: 'workHour' }
      }).then(res => {
        res.forEach(element => {
          element['key'] = element.dicCode;
          element['value'] = element.dicName;
        });
        self.workHourList = res;
      });
    },
    getProjList() {
      promise({
        url: PROJ_URL + "/getPersonProjectData",
        method: 'post',
        params: { personCode: this.userInfo.username }
      }).then(res => {
        res.list.forEach(element => {
          element['key'] = element.projCode;
          element['value'] = element.projName;
        });
        this.projList = res.list;

      });
    },
    commitDayReport() {
      var createTime = this.form.createTime;
      var signTime = this.form.signTime;

      delete this.form["createTime"];
      delete this.form["signTime"];
      this.form.reportTime = formatTime(new Date(this.form.reportTime), 'yyyy-MM-dd');
      var self = this;
      //更新实际的补助金额
      var workTotalHour = 0;
      var workTotalSubsidy = 0;
      //0正常  1 项目为空   2 工时为空  3  工作内容为空 4 结算单价类型为空
      var flag = 0;
      var msg = "";
      this.reportDetailList.forEach(element => {
        var projCode = element.projCode;
        var workHour = element.workHour;
        var workDetail = element.workDetail;

        var workSubsidy = element.workSubsidy;
        if (isNullOrEmptyStr(projCode)) {
          flag = 1;
          msg = "请选择项目";
          return;
        }
        if (isNullOrEmptyStr(workHour)) {
          flag = 2;
          msg = "请选择工时";
          return;
        }
        if (isNullOrEmptyStr(workDetail)) {
          flag = 3;
          msg = "请填写工作内容";
          return;
        }
        // 外部人员才有这个验证
        if (this.userInfo.userType === 'outside' && !element.unitPriceType) {
          flag = 4;
          msg = "请选择结算单价类型";
          return;
        }
        if (workSubsidy == null) {
          workSubsidy = 0;
        }
        workTotalHour += parseInt(workHour);
        workTotalSubsidy += parseInt(workSubsidy);
      });
      if (flag != 0) {
        Toast({ message: msg, duration: 1500, position: 'middle', className: "warning" });
        return false;
      }
      if (workTotalHour > 16) {
        Toast({ message: '工作时长不能大于16小时!', duration: 1500, position: 'middle', className: "warning" });
        return false;
      }
      if (workTotalSubsidy > this.workSubsidyAmt) {
        Toast({ message: "工作补贴不能大于" + this.workSubsidyAmt + "元", duration: 1500, position: 'middle', className: "warning" });
        return false;
      }
      this.form.workTotalSubsidy = workTotalSubsidy;
      this.form.workTotalHour = workTotalHour;
      this.form.detailStr = JSON.stringify(this.reportDetailList);
      this.form.type = this.type;
      this.form.detailId = this.detailId;
      promise({
        url: BASIC + '/dayReport/modify',
        method: "post",
        params: this.form
      }).then(res => {
        if (res.code == 0) {
          self.type == '2';
          this.form.createTime = createTime;
          this.form.signTime = signTime;
          Toast({ message: '操作成功!', duration: 1500, position: 'middle', className: "success" });
          this.goBack();
        } else {
          Toast({ message: res.msg, duration: 1500, position: 'middle', className: "error" });
        }
      });
    },
    getUserInfo() {
      var self = this;
      promise({
        url: BASIC + '/dayReport/currInfo',
        method: 'get',
      }).then(res => {
        var resData = res.data;
        self.userInfo = resData;
        self.getProjList();
      });
    },
    //获取日报信息
    getDayReportInfo() {
      promise({
        url: BASIC + '/dayReport/id',
        method: "get",
        params: { id: this.form.id }
      }).then(res => {
        if (res.code == 0 && res.data != null && res.data.id != null) {
          this.form = res.data;
          if (this.type == '2') {
            this.getUserInfo();
          }
        }
      });
    },
    //获取日报详情
    getDayreportDetailInfo() {
      var self = this;
      promise({
        url: BASIC + '/dayReport/detail/mainId',
        method: "get",
        params: { mainId: this.form.id }
      }).then(res => {
        if (res.code == 0 && res.data != null) {
          res.data.forEach(element => {
            if (element.id == self.detailId) {
              self.modifyDetail = element;
            }
            element.workHour = element.workHour + "";
            self.reportDetailList.push(element);
          });
        }
      });
    },
    hourSelectChange(val, data) {
      var missionSubsidy = this.userInfo.missionSubsidy;
      var workHour = data.workHour;
      var totalPirce = this.form.origTotalSubsidy;
      if (workHour <= 2) {
        data.workSubsidy = 0;
        data.origSubsidy = 0
      } else if (workHour > 2 && workHour < 6) {
        if (totalPirce > 0) {
          data.workSubsidy = missionSubsidy * 0.5;
          data.origSubsidy = missionSubsidy * 0.5;
        } else {
          data.workSubsidy = 0;
          data.origSubsidy = 0
        }
      } else if (workHour >= 6) {
        if (totalPirce > 0) {
          data.workSubsidy = missionSubsidy;
          data.origSubsidy = missionSubsidy;
        } else {
          data.workSubsidy = 0;
          data.origSubsidy = 0
        }
      }
    },
    hourProjChange(data) {
      var val = data.projCode;
      var proj = null;
      for (var i = 0; i < this.projList.length; i++) {
        var item = this.projList[i];
        if (item.projCode == val) {
          proj = item;
        }
      }
      if (proj != null && proj != undefined) {
        data.projId = proj.id;
        data.projName = proj.projName;
      }
    },
    compareDate(reportTime, createTime) {
      return formatTime(new Date(reportTime), 'yyyy-MM-dd') == formatTime(new Date(createTime), 'yyyy-MM-dd')
    },
    //获取费用信息
  },
  filters: {
    formatDate(date) {
      if (date == null || date == '') {
        return '';
      }
      return formatTime(new Date(date), 'yyyy年MM月dd日')
    },
    formattime(date) {
      if (date == null || date == '') {
        return '';
      }
      return formatTime(new Date(date), 'hh:mm')
    },
    reportTimeFilter(reportTime, createTime) {
      return formatTime(new Date(reportTime), 'yyyy-MM-dd') == formatTime(new Date(createTime), 'yyyy-MM-dd')
    }
  },

  created() {

  },
  mounted() {
    this.getWorkSubsidyAmt();
    this.getWorkHourList();
    this.getDayReportInfo();
    this.getDayreportDetailInfo();
  }
}



// WEBPACK FOOTER //
// ./src/view/sign/dayReportModify.vue